export enum ExperimentCohort {
  NotEnrolled = 'not-enrolled',
  Variation = 'variation',
  Control = 'control',
}

/* Uncomment this block to test that these properties still hold when editing the types here
// should typecheck
isBooleanFeatureFlagSet('aid_signup.apple.auth.enabled');
getFeatureFlag('aid_signup.apple.auth.enabled', true);

// should not
isBooleanFeatureFlagSet('not-a-real-feature-flag');
getFeatureFlag('aid_signup.apple.auth.enabled', 'false');
*/

export function isBooleanFeatureFlagSet(name: keyof BooleanFeatureFlags): boolean {
  return getFeatureFlag<keyof BooleanFeatureFlags>(name, false);
}

export type KnownFeatureFlag = keyof FeatureFlags;

export function getFeatureFlag<K extends KnownFeatureFlag>(
  name: K,
  defaultValue: Required<FeatureFlags>[K]
): Required<FeatureFlags>[K] {
  if (window.featureFlags && window.featureFlags.hasOwnProperty(name)) {
    // @ts-ignore
    return window.featureFlags[name];
  } else {
    return defaultValue;
  }
}

export type BooleanFeatureFlags = Partial<
  Record<
    | 'aid_signup.microsoft.auth.enabled'
    | 'aid_signup.apple.auth.enabled'
    | 'sign-in-with-slack.enabled'
    | 'aid-frontend.google.login.outage.advisory.enabled'
    | 'aid-frontend.microsoft.login.outage.advisory.enabled'
    | 'aid-frontend.apple.login.outage.advisory.enabled'
    | 'aid-frontend.slack.login.outage.advisory.enabled'
    | 'aid-frontend.google.one.tap.enabled'
    | 'aid-management.recaptcha-sms-enrollment.enabled'
    | 'sign-in-service.recaptcha.score-v3'
    | 'sign-in-service.combo.recaptcha.enabled'
    | 'sign-in-service.check-username.recaptcha.enabled',
    boolean
  >
>;

export type FeatureFlags = BooleanFeatureFlags;
